import React from 'react';
import { Link } from 'react-router';
import axios from 'axios';
import urlBase from '../../../url-base';
import { 
    FaStepBackward, FaWallet, FaExclamationTriangle, 
    FaCheckCircle, FaHeadset, FaFileContract, FaTimesCircle, FaUsers 
} from "react-icons/fa";

class PessoaFisica extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            countLeads: 0,
            countAwaitingSolution: 0,
            countWaitingConfirmation: 0,
            countAwaitingAfterSale: 0,
            countImplantedContracts: 0,
            countCanceledContracts: 0,
            countPending: 0,
            countConfirmacao: 0,

            showPanelPF: true,
            showLeads: true,
            showAwaitingSolution: true,
            showWaitingConfirmation: true,
            showAwaitingAfterSale: true,
            showImplantedContracts: true,
            showCanceledContracts: true,
            showPending: true,
            showConfirmacao: true
        };

        // Cores originais preservadas
        this.colors = {
            red: 'rgba(209, 4, 36, 0.7)',
            purple: '#b778c7',
            green: 'rgba(5, 134, 15, 0.6)',
            darkCyan: 'rgba(0,139,139,0.7)',
            orange: 'rgba(245, 170, 0, 0.8)',
            dimGray: 'rgba(105,105,105, 0.7)',
            blue: 'rgba(2, 17, 199, 0.5)',
            bg: '#f8fafc'
        };
    }

    componentDidMount() {
        this.fetchData();
        this.showBox();
    }

    fetchData() {
        const url = urlBase.loopBack + 'Sales/dataDashboard';
        const dataSubmit = { userId: localStorage.getItem('dental_u') };
        
        axios.post(url, dataSubmit)
            .then((response) => {
                this.setState({
                    countLeads: response.data.leads,
                    countAwaitingSolution: response.data.awaitingSolution,
                    countWaitingConfirmation: response.data.waitingConfirmation,
                    countAwaitingAfterSale: response.data.awaitingAfterSale,
                    countImplantedContracts: response.data.implantedContracts,
                    countCanceledContracts: response.data.canceledContracts,
                    countPending: response.data.pending
                });
            })
            .catch(() => alert('Erro ao buscar indicadores.'));
    }

    showBox() {
        const type = localStorage.getItem('dental_y');
        let stateUpdate = {};

        if (type === 'SALESMAN' || type === 'BROKER' || type === 'BACKOFFICE') {
            stateUpdate.showLeads = false;
        } else if (type === 'REGISTER') {
            stateUpdate = { showLeads: false, showAwaitingSolution: false };
        } else if (type === 'AFTER SALES') {
            stateUpdate = { showLeads: false, showAwaitingSolution: false, showWaitingConfirmation: false };
        }

        this.setState(stateUpdate);
    }

    goBack() {
        window.history.back();
    }

renderMetricCard(title, count, path, color, Icon) {
    const cardStyle = {
        display: 'flex',
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        marginBottom: '15px',
        minHeight: '85px',
        alignItems: 'center',
        border: '1px solid #e2e8f0',
        textDecoration: 'none',
        color: 'inherit',
        overflow: 'hidden',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
    };

    const iconContainerStyle = {
        width: '70px', 
        height: '85px', 
        backgroundColor: color, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        color: '#fff',
        WebkitFlexShrink: 0,
        msFlexShrink: 0,
        flexShrink: 0 
    };

    const countBadgeStyle = {
        backgroundColor: '#f1f5f9',
        borderRadius: '50%',
        minWidth: '40px',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 'bold',
        fontSize: '18px',
        color: '#334155',
        marginLeft: '10px'
    };

    return (
        <Link to={path} style={{ textDecoration: 'none' }}>
            <div style={cardStyle} className="card-hover">
                <div style={iconContainerStyle}>
                    <Icon size={24} />
                </div>
                <div style={{ 
                    flex: 1, 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    padding: '10px 15px' 
                }}>
                    <span style={{ 
                        fontSize: '13px', 
                        fontWeight: 'bold', 
                        color: '#475569', 
                        lineHeight: '1.2'
                    }}>
                        {title}
                    </span>
                    <div style={countBadgeStyle}>
                        {count}
                    </div>
                </div>
            </div>
        </Link>
    );
}

render() {
    if (!this.state.showPanelPF) return null;

    return (
            <div style={{ padding: '40px 15px', backgroundColor: this.colors.bg, minHeight: '100vh' }}>
                <style>{`
                    .card-item-hover:hover {
                        background-color: #f1f5f9 !important;
                        transform: translateY(-2px);
                        box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);
                    }
                `}</style>

                <div style={{ maxWidth: '600px', margin: '0 auto' }}>
                    {/* Botão Voltar */}
                    <div 
                        onClick={this.goBack.bind(this)} 
                        style={{ cursor: 'pointer', color: '#64748b', display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px', fontFamily: 'sans-serif', fontSize: '14px' }}
                    >
                        <FaStepBackward size={12} /> Voltar
                    </div>

            <div style={{ textAlign: 'center', fontSize: '18px', fontWeight: 'bold', color: '#334155', marginBottom: '25px' }}>
                PAINEL DE GESTÃO PESSOA FÍSICA 
            </div>

            <div className="grid-container">
                {this.state.showAwaitingSolution && this.renderMetricCard('AGUARDANDO CONFIRMAÇÃO', this.state.countAwaitingSolution, urlBase.client + 'panel/proposals/awaitingSolution', this.colors.red, FaWallet)}
                {/* Continuar com a opção de disponibilizar propostas confirmadas pelo RF
                {this.state.showConfirmacao && this.renderMetricCard('CONFIRMADOS', this.state.countConfirmacao, urlBase.client + 'panel/proposals/confirmado', this.colors.purple, FaExclamationTriangle)}
                */}
                {this.state.showPending && this.renderMetricCard('PENDENTES', this.state.countPending, urlBase.client + 'panel/proposals/pending', this.colors.purple, FaExclamationTriangle)}
                {this.state.showWaitingConfirmation && this.renderMetricCard('PROPOSTAS EM VALIDAÇÃO', this.state.countWaitingConfirmation, urlBase.client + 'panel/proposals/waitingConfirmation', this.colors.green, FaCheckCircle)}
                {this.state.showAwaitingAfterSale && this.renderMetricCard('AGUARDANDO PÓS VENDA', this.state.countAwaitingAfterSale, urlBase.client + 'panel/proposals/awaitingAfterSale', this.colors.darkCyan, FaHeadset)}
                {this.state.showImplantedContracts && this.renderMetricCard('IMPLANTADOS (60 DIAS)', this.state.countImplantedContracts, urlBase.client + 'panel/proposals/implantedContracts', this.colors.orange, FaFileContract)}
                {this.state.showCanceledContracts && this.renderMetricCard('CANCELADOS (60 DIAS)', this.state.countCanceledContracts, urlBase.client + 'panel/proposals/canceledContracts', this.colors.dimGray, FaTimesCircle)}
                {this.state.showLeads && this.renderMetricCard('INTERESSADOS', this.state.countLeads, '#', this.colors.blue, FaUsers)}
            </div>
        </div>
        </div>
    );
}
}

export default PessoaFisica;


/** WEBPACK FOOTER **
 ** ./src/components/Panel/ResumeNew/PessoaFisica.js
 **/